import React from 'react';
const calendarIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/calendar-rouded.svg';
const carIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/car-rouded.svg';
const vaccineIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/vaccine-rouded.svg';
const examIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/exam-icon.svg';
const pinIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/pin-rouded.svg';
const homeIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home-icon.svg';
const ConferenceIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/conference-cam.svg';
const PatientIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/patient.svg';
const stethoscopeIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/estetoscopio.svg';

import * as S from '../../styles';
import { CareTypes, CARE_TYPES_MAPPED, SCHEDULES_TYPES_MAPPED } from '../..';
import { formatDatetime } from '../../../../utils/dates';
import Info from '../Info';
import { specialistAppointment } from '../../../../models/specialistAppointment';

export const ICON_BY_SCHEDULE_TYPE = {
  EXAM: examIcon,
  IMMUNIZATION: vaccineIcon,
  DEFAULT: PatientIcon
};

const CARE_TYPES_ICON: { [index: string]: string } = {
  PRESENTIAL: pinIcon,
  EINSTEIN_TO_YOU: homeIcon,
  TELEMEDICINE: ConferenceIcon,
  DRIVE_THRU: carIcon
};

type AppointmentSGHProps = {
  appointment: specialistAppointment;
};

export const AppointmentSpecialist: React.FC<AppointmentSGHProps> = ({ appointment }) => {
  let dateAppointment = '';
  if (appointment?.scheduleDate && appointment.scheduleTime)
    dateAppointment = `${appointment.scheduleDate}T${appointment.scheduleTime}`;

  const handleTitleByCareType = (careType: string, unitName?: string) => {
    if (careType === CareTypes.TELEMEDICINE) return CARE_TYPES_MAPPED.TELEMEDICINE;
    if (careType === CareTypes.PRESENTIAL) return unitName;
    if (careType === CareTypes.DRIVE_THRU) return `${CARE_TYPES_MAPPED.DRIVE_THRU} ${unitName}`;
    return unitName;
  };
  return (
    <S.Schedule>
      <Info
        icon={<img src={stethoscopeIcon} alt="Specialist" />}
        title="Consulta médica"
        subtitle={appointment.resourceName}
      />

      <Info
        icon={<img src={calendarIcon} />}
        title="Data"
        subtitle={dateAppointment && formatDatetime(new Date(dateAppointment))}
      />
      <Info
        icon={<img src={CARE_TYPES_ICON[appointment.attendance_type] || CARE_TYPES_ICON.PRESENTIAL} />}
        title="Local"
        subtitle={handleTitleByCareType(appointment?.attendance_type, appointment.unit_name) || ''}
        adress={appointment?.attendance_type !== CareTypes.TELEMEDICINE ? appointment?.address : undefined}
      />
    </S.Schedule>
  );
};
